import React from 'react'
import Enrolledcoursecomp from '../../components/student/enrolledcourse'
export default function Enrolledcourse() {
  return (
    <div>
        <Enrolledcoursecomp/>
    </div>
  )
}
